// Imports (Parent)
import {
  init as initialInit,
} from '../../../common/entries/header/init';

// Imports (Organisms)
import {
  init as initHeader,
} from '../../organism/header';
import { init as footerInit } from '../../organism/footer';

// Imports (Events)
import {
  headerReadyEventName,
} from '../../../common/Events';

import * as Utils from '../../../common/Utils';

// Imports (Algolia)
import {
  instantSearchHeaderInit,
} from '../../instantSearch';

let isAISHeaderInit = false;

/**
 * Initialization of the header part of the website.
 */
function init() {
  initialInit();
  footerInit();

  $(document).on(headerReadyEventName, () => {
    if (Utils.isAlgoliaOn()) {
      // Call header init of the Algolia instant search feature
      if (!isAISHeaderInit) {
        instantSearchHeaderInit();
        isAISHeaderInit = true;
      }
    }

    initHeader();
  });
}

// Named exports - Functions
export {
  init,
};

export default init;



// WEBPACK FOOTER //
// ./js/desktop/entries/header/init.js